import { Icon } from './ui/Icon.js';

export interface DateInputProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  'data-testid'?: string;
  'aria-label'?: string;
}

export function DateInput({
  value,
  onChange,
  className = '',
  'data-testid': testId,
  'aria-label': ariaLabel,
}: DateInputProps) {
  return (
    // Spec 246 (review P0-2): the review measured this input computing
    // padding-left 12px despite `pl-8`, with the calendar glyph over the date.
    // Kridt's Field-with-icon wrapper owns the geometry instead of a utility
    // that the cascade could — and did — discard.
    // Spec 249: the native picker glyph drew a second calendar at the far end;
    // .hub-input--date makes it an invisible overlay across the whole field,
    // so there is one glyph and the whole field opens the picker.
    <span className={`hub-input-wrap ${className}`}>
      <Icon name="bx-calendar" />
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="hub-input hub-input--date appearance-none transition-colors focus-visible:outline-none"
        aria-label={ariaLabel}
        data-testid={testId}
      />
    </span>
  );
}
